import { render, staticRenderFns } from "./Cotiza.vue?vue&type=template&id=54755a3e&scoped=true"
import script from "./Cotiza.vue?vue&type=script&lang=js"
export * from "./Cotiza.vue?vue&type=script&lang=js"
import style0 from "./Cotiza.vue?vue&type=style&index=0&id=54755a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54755a3e",
  null
  
)

export default component.exports